import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Container,
    makeStyles,
    CircularProgress,
    Card,
    Divider
} from "@material-ui/core";

import { useSnackbar } from "notistack";
import { useHistory } from "react-router-dom";
import {bundleOptions} from "../../../Constants/credits";
import {createCredit, setInvoicePreview} from "../../../redux/credits/credits.actions";
import {RootState, useAppDispatch} from "../../../redux/store";
import {useSelector} from "react-redux";
import {getUserByID} from "../../../redux/user/user.actions";
import moment from "moment/moment";
import PaymentForm from "../../PaymentForm/PaymentForm";

const useStyles = makeStyles({
    containerWrapper: {
        marginTop: "20vh"
    },
});

const InvoiceCredits = () => {
    const classes = useStyles();
    let history = useHistory();
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [creditsPrice, setCreditsPrice] = useState("");
    const [totalPrice, setTotalPrice] = useState("");
    const [isRequestFinish, setIsRequestFinish] = useState(false);
    const [referralCodeAvailable, setReferralCodeAvailable] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [moneyApplied, setMoneyApplied] = useState("");
    const user = useSelector((state: RootState) => state?.user);
    const credit = useSelector((state: RootState) => state?.credits.newCredit);
    const creditType = useSelector((state: RootState) => state?.credits.creditType);
    const total = +parseFloat(String(totalPrice).replace( /^\D+/g, ""));
    const [disabled, setDisabled] = useState(false);
    const location = useSelector((state: RootState) => state?.common.location);

    useEffect(() => {
        setIsLoading(true);
        dispatch(getUserByID(user.userId))
            .then(userEntity => {
                let referralCodeExits = false;
                if (Object.prototype.hasOwnProperty.call(userEntity, "referralCodeRequest")){
                    if(userEntity.referralCodeRequest.referralCodeRequestStatus !== "APPLIED" && moment(userEntity.referralCodeRequest.expiredAt) > moment()) {
                        referralCodeExits = true;
                        setReferralCodeAvailable(true);
                    }
                }
                const params = location ? {
                    usState: location,
                    ...credit
                }
                    : {
                        ...credit
                    };
                if(referralCodeExits) {
                    Object.assign(params, {referralCodeRequestId: userEntity.referralCodeRequest.id});
                }
                dispatch(setInvoicePreview(params))
                    .then((invoice) => {
                        setCreditsPrice(invoice.charges.find(charge => charge.type === "CREDIT").amount);
                        if(referralCodeExits) {
                            setMoneyApplied(invoice.charges.find(charge => charge.type === "REFERRAL_CODE").amount);
                        }
                        setTotalPrice(invoice.totalAmount);
                        const updatedCreditEntity = {
                            ...credit,
                            paymentRequest: {
                                ...credit.paymentRequest,
                                amount: invoice.totalAmount
                            },
                        };
                        if(referralCodeAvailable) {
                            Object.assign(updatedCreditEntity, {referralCodeRequestId: user.referralCodeRequest.id});
                        }
                        dispatch(createCredit(updatedCreditEntity));
                    }).catch((err) => {
                        // enqueueSnackbar(err.errorMessage, {variant: "error"});
                        console.log(err);
                    }).finally(() => setIsLoading(false));
            })
            .catch((err) => {
                enqueueSnackbar(err.errorMessage, {variant: "error"});
            });
    }, []);

    return(
        <Container className={classes.containerWrapper} maxWidth="md">
            <Card variant="outlined" style={{padding: 20}}>
                <Typography variant="h2" gutterBottom>Credits Purchase Summary</Typography>
                <Typography variant="h4" gutterBottom>{bundleOptions[creditType].find(option => option.name === credit.creditPrice).value} Credits Bundle</Typography>
                <Divider variant="middle" style={{marginTop: 25, marginBottom: 25}}/>
                {
                    isLoading ?
                        <Box width="100%" height="150px" display="flex" justifyContent="center" alignItems="center">
                            <CircularProgress />
                        </Box>
                        :
                        <>
                            <Box display="flex" justifyContent="space-between" marginBottom="15px">
                                <Typography variant="h5">
										Description
                                </Typography>
                                <Typography variant="h5">
										Amount
                                </Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" marginBottom="15px">
                                <Typography>
									Credits Price
									({bundleOptions[creditType].find(option => option.name === credit.creditPrice).value} Credits)
                                </Typography>
                                <Typography>
                                    {creditsPrice}
                                </Typography>
                            </Box>
                            {
                                moneyApplied &&
								<Box display="flex" justifyContent="space-between" marginBottom="15px">
								    <Typography>
										Referral Applied
								    </Typography>
								    <Typography>
										({moneyApplied})
								    </Typography>
								</Box>
                            }
                            <Box display="flex" justifyContent="space-between" marginBottom="15px">
                                <Typography style={moneyApplied? {fontWeight: 700} : {}}>
									Total
                                </Typography>
                                <Typography style={moneyApplied? {fontWeight: 700} : {}}>
                                    {totalPrice}
                                </Typography>
                            </Box>
                        </>
                }
                <Divider variant="middle" style={{marginTop: 25, marginBottom: 25}}/>
                <Typography variant="h5" style={{paddingBottom: 20}}>Payment Method</Typography>
                <PaymentForm
                    price={total}
                    purchaseType="creditsPurchase"
                    disabled={disabled || isRequestFinish}
                    setIsRequestFinish={setIsRequestFinish}
                    setDisabled={setDisabled}
                />
            </Card>
        </Container>
    );
};

export default InvoiceCredits;
